import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-sm",
  "use": "check-sm-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"check-sm\"><path d=\"M5.854 7.146a.5.5 0 10-.708.708L7.5 10.207l4.354-4.353a.5.5 0 00-.708-.708L7.5 8.793 5.854 7.146z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol